import { composeWithDevTools } from "@redux-devtools/extension";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { BACKEND_URL } from "../config";
import { partnerRegisterReducer } from "./Reducers/bizDevReducer";
import { chatbotSessionsReducer } from "./Reducers/chatbotSessionReducer";
import {
  allValetTeamGetReducer,
  deleteTeamMemberReducer,
  maidCreateReducer,
  maidGetAllReducer,
  maidGetEarningsReducer,
  maidUpdateReducer,
  payMaidReducer,
  staffGetAllReducer,
  teamMemberAddReducer,
  valetTeamGetReducer,
  verifyPaymentReducer,
  verifyBulkTeamsReducer,
} from "./Reducers/maidReducer";
import {
  adminXReportsByDateReducer,
  adminXReportsReducer,
  failedPaymentGetAllReducer,
  getClientPaymentsReducer,
  getPaymentReportsReducer,
  getTeamPayoutsReducer,
  paymentsByDateReducer,
} from "./Reducers/paymentReducer";
import {
  reportListDownloadtReducer,
  selecetiveMaidReportReducer,
} from "./Reducers/reportsDownloadReducer";
import { navigationReducer } from "./Reducers/tabReducers";
import { teamTipReducer } from "./Reducers/teamTipReducer";
import {
  addUserReducer,
  getRoleUsersReducer,
  getRolesReducer,
  hotelUpdateReducer,
  mfaSettingToggleReducer,
  monthlyCommissionReducer,
  resetPasswordReducer,
  roleReducer,
  roleUserUpdateReducer,
  shiftCommissionReducer,
  singleUserReducer,
  updateRoleReducer,
  userDetailsReducer,
  userListReducer,
  userLoginReducer,
  userRegisterReducer,
  userUpdateProfileReducer,
} from "./Reducers/userReducer";
import clientReducer from "./slices/clientSlice.js";
import maidReducer from "./slices/maidSlice.js";
import onboardingFormReducer from "./slices/onboardingFormSlice.js";
import monthlyReportsReducer from "./slices/MonthlyReportSlice.js";

const reducers = combineReducers({
  monthlyReports: monthlyReportsReducer,
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userDetails: userDetailsReducer,
  client: clientReducer,
  maids: maidReducer,
  onboardingForm: onboardingFormReducer,
  userUpdate: userUpdateProfileReducer,
  hotelUpdate: hotelUpdateReducer,
  userList: userListReducer,
  singleUser: singleUserReducer,
  getRoles: getRolesReducer,
  addRole: roleReducer,
  maidsList: maidGetAllReducer,
  maidCreate: maidCreateReducer,
  maidUpdate: maidUpdateReducer,
  maidEarnings: maidGetEarningsReducer,
  payMaid: payMaidReducer,
  roleUsers: getRoleUsersReducer,
  addRoleUser: addUserReducer,
  teamTipData: teamTipReducer,
  valetTeams: valetTeamGetReducer,
  getAllValetTeams: allValetTeamGetReducer,
  addTeamMember: teamMemberAddReducer,
  deleteTeamMember: deleteTeamMemberReducer,
  verifyPayment: verifyPaymentReducer,
  partnerRegister: partnerRegisterReducer,
  failedPayments: failedPaymentGetAllReducer,
  updateRole: updateRoleReducer,
  updateRoleUser: roleUserUpdateReducer,
  getAllStaff: staffGetAllReducer,
  selectiveMaidData: selecetiveMaidReportReducer,
  reportListData: reportListDownloadtReducer,
  monthlyCommission: monthlyCommissionReducer,
  shiftCommission: shiftCommissionReducer,
  resetPassword: resetPasswordReducer,
  navigation: navigationReducer,
  paymentReports: getPaymentReportsReducer,
  paymentsByDate: paymentsByDateReducer,
  teamPayouts: getTeamPayoutsReducer,
  clientPayments: getClientPaymentsReducer,
  chatbotSessions: chatbotSessionsReducer,
  adminXReports: adminXReportsReducer,
  adminXReportsByDate: adminXReportsByDateReducer,
  mfaSettingToggle: mfaSettingToggleReducer,
  verifyBulkTeams: verifyBulkTeamsReducer,
});

const userInfoFromStorage =
  localStorage.getItem("userInfo") !== null &&
  localStorage.getItem("userInfo") !== undefined
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
const initialState = {
  userLogin: {
    userInfo: userInfoFromStorage,
  },
};

const middleWares = [thunk];
// Use DevTools only in development
const composeEnhancers =
  BACKEND_URL !== "/"
    ? composeWithDevTools(applyMiddleware(...middleWares))
    : compose(applyMiddleware(...middleWares));

const store = createStore(reducers, initialState, composeEnhancers);

export default store;
